import { Helper } from "../core/util/helper";
import {AppHelper} from "../appHelper";
import {JourneyHelper} from "../core/util/journeyHelper";
import { AssignmentTraveldataModel } from "./resourcePlanning";
import { AssignmentUtilizationInfo } from "../resourcePlanningScheduler/resourcePlanningScheduler";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";

export default class TravaldataSummary extends React.Component<TravaldataSummaryProps, any> {
    common = new AppHelper();
    translations: StringKeyDictionary<string>;

    constructor(props) {
        super(props);
    }
    
    private _popUpStyle: React.CSSProperties = {
        display: "flex",
        padding: 5,
        flexDirection: "column",
        fontFamily: "monospace",
        fontSize: "8"
    };
    
    private _labelStyle: React.CSSProperties = {
        margin: "10px"
    };
    private _labelStyleError: React.CSSProperties = {
        margin: "10px",
        color: "red"
    };
    
    private _tableStyle: React.CSSProperties = {
        width: "100%",
        margin: "10px"
    };

    private _bodyStyle: React.CSSProperties = {
    };

    private _tdStyle: React.CSSProperties = {
        lineHeight: "20px"
    };

    private _tdStyleCenter: React.CSSProperties = {
        lineHeight: "20px",
        textAlign: "center"
    };
    
    private _trStyle: React.CSSProperties = {
     
    };
    
    private  _toHHMM(min): string  {
        return Helper.dates.getSecToHHMM(min * 60)
    };

    render() {
        
        let util;
        if (this.props.assignmentUtilizationInfo != null && this.props.assignmentUtilizationInfo.work.length >= 1) {
            if (this.props.assignmentUtilizationInfo.work.length == 1) {
                const firstDay = this._toHHMM(this.props.assignmentUtilizationInfo.arrival[0]);
                const lastDay = this._toHHMM(this.props.assignmentUtilizationInfo.departure[0]);
                const middleWork = this._toHHMM(this.props.assignmentUtilizationInfo.work[0]);
                util = (<div style={this._labelStyle}>{this.props.translations.auslastung}: →{firstDay} - {middleWork} - ←{lastDay}</div>);
            }
            else
            {
                if (this.props.assignmentUtilizationInfo.work.length == 2) {
                    const firstDay = this._toHHMM(this.props.assignmentUtilizationInfo.arrival[0]);
                    const middleWork1 = this._toHHMM(this.props.assignmentUtilizationInfo.work[0]);
                    const middleWork2 = this._toHHMM(this.props.assignmentUtilizationInfo.work[1]);
                    const lastDay = this._toHHMM(this.props.assignmentUtilizationInfo.departure[1]);
                    util = (<div style={this._labelStyle}>{this.props.translations.auslastung}: →{firstDay} {middleWork1} - {middleWork2} ←{lastDay}</div>);
                }
                else {
                    const firstDay = "→" + this._toHHMM(this.props.assignmentUtilizationInfo.arrival[0]) + "  " + this._toHHMM(this.props.assignmentUtilizationInfo.work[0]);

                    const idx = this.props.assignmentUtilizationInfo.work.length - 1;
                    const lastDay = this._toHHMM(this.props.assignmentUtilizationInfo.work[idx]) + " ←" + this._toHHMM(this.props.assignmentUtilizationInfo.departure[idx]);

                    const dic = new Map<string, number>();
                    for (var i = 1; i < idx; i++) {
                        const w = this._toHHMM(this.props.assignmentUtilizationInfo.work[i]);
                        const c = dic.has(w) ? dic.get(w) + 1 : 1;
                        dic.set(w, c);
                    }

                    const list: Array<string> = [];

                    for (let [key] of dic) {
                        const c = dic.get(key);
                        list.push(key + "x" + c.toString());
                    }
                    list.sort();
                    const middleWork = list.join(", ");

                    util = (
                        <div>
                            <div style={this._labelStyle}>{this.props.translations.auslastung}:</div>
                            <table style={this._tableStyle}>
                                <tbody style={this._bodyStyle}>
                                <tr style={this._trStyle}>
                                    <td style={this._tdStyle}>{this.props.translations.erstertag}</td>
                                    <td style={this._tdStyle}>{this.props.translations.gesamttagearbeitszeit}</td>
                                    <td style={this._tdStyle}>{this.props.translations.letztertag}</td>
                                </tr>
                                <tr style={this._trStyle}>
                                    <td style={this._tdStyle}>{firstDay}</td>
                                    <td style={this._tdStyleCenter}>{middleWork}</td>
                                    <td style={this._tdStyle}>{lastDay}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    );
                }
            }
        } else
            util = (<div style={this._labelStyleError}>{this.props.translations.auslastungunbekannt}</div>);
        
        let travel;
        let kind1;
        let kind2;
        if (this.props.assignmentTraveldata != null && this.props.assignmentTraveldata.traveldataInfo.valid) {
            
            let k1 =  null;
            if (this.props.assignmentTraveldata?.wayThere?.journeyLeg != null)
                k1 = JourneyHelper.getJourneyLegText(this.props.assignmentTraveldata.wayThere.journeyLeg, "wayThere", false);

            let k2 =  null;
            if (this.props.assignmentTraveldata?.wayBack?.journeyLeg != null)
                k2 = JourneyHelper.getJourneyLegText(this.props.assignmentTraveldata.wayBack.journeyLeg, "wayBack", false);
            
            if (k1 != null)
                kind1 = (<div style={this._labelStyle}>{k1}</div>);
            if (k2 != null)
                kind2 = (<div style={this._labelStyle}>{k2}</div>);
        
            
            //const isAir = this.props.assignmentTraveldata.traveldataInfo.isAirlineCalculation ? 'x' : '-';
            //air = (<div style={this._labelStyle}>[{isAir}] Luftlinie</div>);

            
            
            
            const fromHome = this.props.assignmentTraveldata.traveldataInfo.fromHome ? this.props.translations.ressource : this.props.translations.einsatz;
            const backHome = this.props.assignmentTraveldata.traveldataInfo.backHome ? this.props.translations.ressource : this.props.translations.einsatz;

            const startIst = kendo.toString(kendo.parseDate(this.props.assignmentTraveldata.assignmentTimes.startIst as string), "ddd") + ", "
                kendo.toString(kendo.parseDate(this.props.assignmentTraveldata.assignmentTimes.startIst as string), "g");
            const endeIst = kendo.toString(kendo.parseDate(this.props.assignmentTraveldata.assignmentTimes.endeIst as string), "ddd") + ", " +
                kendo.toString(kendo.parseDate(this.props.assignmentTraveldata.assignmentTimes.endeIst as string), "g");
            const arbeitsBeginn = kendo.toString(kendo.parseDate(this.props.assignmentTraveldata.assignmentTimes.arbeitsBeginn as string), "ddd") + ", " +
                kendo.toString(kendo.parseDate(this.props.assignmentTraveldata.assignmentTimes.arbeitsBeginn as string), "g");
            const arbeitsEnde = kendo.toString(kendo.parseDate(this.props.assignmentTraveldata.assignmentTimes.arbeitsEnde as string), "ddd") + ", " +
                kendo.toString(kendo.parseDate(this.props.assignmentTraveldata.assignmentTimes.arbeitsEnde as string), "g");

            travel = (
                <div>
                    <table style={this._tableStyle}>
                        <tbody style={this._bodyStyle}>
                        <tr style={this._trStyle}>
                            <td style={this._tdStyle}>{this.props.translations.anfahrt}</td>
                            <td style={this._tdStyle}>{startIst}</td>
                            <td style={this._tdStyle}>{fromHome}</td>
                            <td style={this._tdStyle}>{this.props.assignmentTraveldata.traveldataInfo.fromInfo}</td>
                        </tr>
                        <tr style={this._trStyle}>
                            <td style={this._tdStyle}>{this.props.translations.arbeitsbeginn}</td>
                            <td style={this._tdStyle}>{arbeitsBeginn}</td>
                            <td style={this._tdStyle}>&nbsp;</td>
                            <td style={this._tdStyle}>{this.props.assignmentTraveldata.traveldataInfo.summary}</td>
                        </tr>
                        <tr style={this._trStyle}>
                            <td style={this._tdStyle}>{this.props.translations.arbeitsende}</td>
                            <td style={this._tdStyle}>{arbeitsEnde}</td>
                            <td style={this._tdStyle}>&nbsp;</td>
                            <td style={this._tdStyle}>{this.props.assignmentTraveldata.traveldataInfo.summary}</td>
                        </tr>
                        <tr style={this._trStyle}>
                            <td style={this._tdStyle}>{this.props.translations.zuruck}</td>
                            <td style={this._tdStyle}>{endeIst}</td>
                            <td style={this._tdStyle}>{backHome}</td>
                            <td style={this._tdStyle}>{this.props.assignmentTraveldata.traveldataInfo.backInfo}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            );
        } else {
            if (!this.props.isContainer) {
                if (this.props.assignmentTraveldata == null)
                    travel = (<div style={this._labelStyleError}>{this.props.translations.reisedatenfehler}</div>);
                if (!this.props.assignmentTraveldata.traveldataInfo.valid)
                    travel = (<div style={this._labelStyleError}>{this.props.translations.reisedatenungultig}</div>);
            }
        }
        
        return (
            <div style={this._popUpStyle}>
                {kind1}
                {kind2}
                {util}
                {travel}
            </div>
        );
    }
}

export interface TravaldataSummaryProps {
    assignmentTraveldata?: AssignmentTraveldataModel,
    assignmentUtilizationInfo?: AssignmentUtilizationInfo,
    firstAssignment: boolean,
    lastAssignment: boolean,
    continiuesJourney: boolean
    isContainer: boolean;
    
    translations: { 
        arbeitsbeginn: string;
        arbeitsende: string;
        auslastung: string;
        erstertag: string;
        letztertag: string;
        gesamttagearbeitszeit: string;
        auslastungunbekannt: string;
        luftlinie: string;
        ressource: string;
        einsatz: string;
        anfahrt: string;
        zuruck: string;
        reisedatenfehler: string;
        reisedatenungultig: string;
    }
}